import Cookies from "js-cookie";

export const TOKEN_COOKIE = "DBtoken";

export const SESSION_CACHE_KEYS = [
  "assignedOrders",
  "unassignedOrders",
  "orderDetails",
];

export const clearSessionCache = () => {
  SESSION_CACHE_KEYS.forEach((key) => sessionStorage.removeItem(key));
};

export const startSession = (token, options = {}) => {
  clearSessionCache();
  Cookies.set(TOKEN_COOKIE, token, options);
};

export const signOut = () => {
  Cookies.remove(TOKEN_COOKIE);
  clearSessionCache();
};
